import React, { useState, useEffect, useCallback } from 'react';
import logo from './logo.svg';
import './App.css';
import { HeadTag } from './pages/components/HeadTag';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import { Page503 } from './pages/Page503';
import { Page404 } from './pages/Page404';
import { Index } from './pages/Index';
import LoginPage from './pages/LoginPage'
import Dashboard from './pages/Dashboard';
import Inbox from './pages/Inbox';

function App() {

    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [loggedInUser, setLoggedInUser] = useState<string | null>(null); // To display logged-in user
  const [ profile, setProfile ] = useState([] as any);
  const [page, setPage] = useState<string | null>(null);

  // Simulate initial loading and check for login status (e.g., from session storage)
  useEffect(() => {
    const storedLoginStatus = localStorage.getItem('isLoggedIn');
    const storedUser = localStorage.getItem('loggedInUser');
    const storedRememberMe = localStorage.getItem('rememberMe'); // Check rememberMe flag

    setPage(localStorage.getItem('page'));

    if (storedLoginStatus === 'true' && storedUser && storedRememberMe === 'true') {
      setIsLoggedIn(true);
      setLoggedInUser(storedUser);
    }
    setLoading(false); // Done with "loading"
  }, []);

    // Function to handle successful login from LoginPage
  const handleLoginSuccess = useCallback((username: string, rememberMe: boolean) => {
    setIsLoggedIn(true);
    setLoggedInUser(username);
    localStorage.setItem('loggedInUser', username);

        const data = {
          "firstName": "Sampath",
          "lastName": "Ekanayake",
          "picture": null,
          "email": "sampath@travsyslabs.com",
          "provider": "Internal"
        };
    localStorage.setItem('profile', JSON.stringify(data));

    // Only persist login status if "Remember Me" is checked
    if (rememberMe) {
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('rememberMe', 'true');
      window.location.href = '/'; // Redirect to home/dashboard after login
    } else {
      // If not remembered, ensure these are cleared on logout/browser close (though localStorage persists)
      // For a true "session-only" login, you'd use sessionStorage here.
      // For simplicity and matching localStorage persistence, we'll just not set 'rememberMe' to true.
      localStorage.removeItem('isLoggedIn'); // Clear if not remembered
      localStorage.removeItem('rememberMe');
    }
  }, []);



    // Conditional rendering based on login status
  if (!isLoggedIn || page==='Login') {
     return <LoginPage onLoginSuccess={handleLoginSuccess} />;
    //return <LoginPage />;
  } else if (page && page==='Inbox') {
    return <Inbox />;
  } else if (page && page==='Dashboard') {
    return <Dashboard />;
  }


  return (
    <div className="App">

        <HeadTag title={"TSL-CRM"}/>
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<Dashboard />}></Route>
            <Route path='/inbox' element={<Inbox />}></Route>
            {/* <Route path='/contact' element={<Contact />}></Route>
            <Route path='/login' element={<Login />}></Route>
            <Route path="/test" element={<TestPage />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/my-profile" element={<MyProfile />} /> */}

            <Route path="/login" element={<LoginPage onLoginSuccess={handleLoginSuccess} />} />
            <Route path="/503" element={<Page503 />} />
            <Route path="*" element={<Page404/>}  />
          </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
